




























































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
})
export default class extends Vue {
  @Prop() private WxQrCodePosterList!: any;
  @Prop() private page!: any;
  @Provide() GetQrCodeRowVisible: boolean = false;
  @Provide() BeautifyQrCodeVisible: boolean = false;
  @Provide() loading: boolean = false;
  @Provide() addQrCodeVisble: boolean = false;
  @Provide() wxQrCodePosterListModel: any = {};
  @Provide() QrCodeUrl: any = "";
  @Provide() NickName: any = "";
  @Provide() optionFansList: any = [];
  @Provide() sceneId: string = "";
  @Provide() GetQrCodePosterDetailaList: any = [];
  @Provide() dataList: any = [];
  @Provide() currentPage: number = 1;
  @Provide() pagesize: number = 10;
  @Provide() total: number = 0;
  @Provide() scrollHeight: number = 500; //当前高度
  @Provide() dialogWidth: any = "500px";
  @Provide() SearchKeywords: string = "";
  @Provide() iframeUrl: string = "";
  async created() {
    //console.log(this.WxQrCodePosterList);
    this.scrollHeight = document.body.scrollHeight - 260;
    this.wxQrCodePosterListModel = this.WxQrCodePosterList;
    if (this.page.pagesize) this.pagesize = this.page.pagesize;
    if (this.page.currentPage) this.currentPage = this.page.currentPage;
    this.GetQrCodePosterDetaila();
  }
  //返回操作主页
  back() {
    this.page.aid = this.WxQrCodePosterList.Aid;
    this.$emit("formData", {
      pagename: "listForm",
      pageinfo: this.wxQrCodePosterListModel,
      page: this.page
    });
  }
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.GetQrCodePosterDetaila();
  }
  private handleCurrentChange(val: any) {
    this.currentPage = val;
    this.GetQrCodePosterDetaila();
  }
  //测试弹出框选择人
  async remoteMethod(query: any) {
    if (query) {
      let params: any = {
        Input: [
          {
            Name: "AppFansSelect",
            Value: {
              Aid: this.wxQrCodePosterListModel.Aid,
              NickName: query,
              OpenID: "",
              Sex: -1
            }
          }
        ]
      };
      this.loading = true;
      this.optionFansList = [];
      var res: any = await httpApi.SarchFansList(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        // this.optionFansList =;
        res.output[0].value.forEach((element: any) => {
          this.optionFansList.push({
            label: element.NickName,
            value: element.OpenID
          });
          //this.temOptionList.push({ label: element.ElementName, value: element.ElementCode })
        });
        this.$forceUpdate();
        //console.log(this.optionFansList);
      } else {
        this.$router.push("/");
        //  this.$message.error("失败：" + res.ErrorMessage);
      }
    }
  }
  addQrCode() {
    this.GetQrCodeRowVisible = true;
    this.QrCodeUrl = "";
    this.NickName = "";
    this.wxQrCodePosterListModel.QrCodeVal = "";
    this.wxQrCodePosterListModel.Status = 2;
    this.addQrCodeVisble = true;
  }
  //生成二维码地址
  async subGetQrCodeRow() {
    if (!this.wxQrCodePosterListModel.QrCodeVal || !this.NickName) {
      this.$message.error("请输入内容！");
    } else {
      this.wxQrCodePosterListModel.NickName = this.NickName;
      let params: any = {
        Input: [
          {
            Name: "model",
            value: this.wxQrCodePosterListModel
          }
        ]
      };
      this.loading = true;
      var res: any = await httpApi.GetQrCodeData(params);
      this.loading = false;
      // console.log(res);
      if (res.ErrorCode == 0) {
        this.QrCodeUrl = res.output[0].value;
        this.GetQrCodePosterDetaila();
        this.addQrCodeVisble = false;
      } else {
        this.$message.error("生成失败：" + res.ErrorMessage);
      }
    }
  }

  //删除
  deleteRow(data: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      data.ActionName = "DELETE";
      let params: any = {
        Input: [
          {
            Name: "model",
            value: data
          }
        ]
      };
      //console.log(params);
      var res: any = await httpApi.SaveQrCodePosterDetail(params);
      //console.log(res);
      if (res.ErrorCode == 0) {
        this.$message.success("删除成功!");
        //保存成功后传个刷新方法过去
        this.GetQrCodePosterDetaila();
      } else {
        this.$message.error("删除失败：" + res.ErrorMessage);
      }
    });
  }
  async beautifyQrCode() {
    this.BeautifyQrCodeVisible = true;
    this.dialogWidth = "1025px";
    //console.log(this.QrCodeUrl);

    let params: any = {
      Input: [
        {
          Name: "codeData",
          value: this.QrCodeUrl
        }
      ]
    };
    this.loading = true;
    var res: any = await httpApi.GetCodeDecoder(params);
    this.loading = false;
    console.log(res);
    if (res.ErrorCode == 0) {
      this.iframeUrl =
        "https://cli.im/api/qrcode/code?text=" + res.output[0].value;
      //this.GetQrCodeRowVisible = true;
      //this.QrCodeUrl = res.output[0].value;
      //this.GetQrCodePosterDetaila("");
    } else {
      this.$message.error(res.ErrorMessage);
    }
  }
  //取生成二维码数据列表
  async GetQrCodePosterDetaila() {
    let status = 255;
    if (this.wxQrCodePosterListModel.EditPoster == 0) {
      status = 2;
    }
    console.log(this.wxQrCodePosterListModel);

    let params: any = {
      Input: [
        {
          Name: "model",
          value: {
            PosterId: this.wxQrCodePosterListModel.PosterId,
            aid: this.wxQrCodePosterListModel.Aid,
            Status: status,
            query: this.SearchKeywords
          }
        },
        {
          Name: "page",
          value: { page: this.currentPage, rows: this.pagesize }
        }
      ]
    };
    this.loading = true;
    var res: any = await httpApi.GetQrCodePosterDetaila(params);
    this.loading = false;
    console.log(res);
    if (res.ErrorCode == 0) {
      this.GetQrCodePosterDetailaList = res.output[0].value;
      this.dataList = res.output[0].value;
      this.total = res.output[1].value;
    } else {
      this.$message.error("取生成二维码数据列表失败：" + res.ErrorMessage);
    }
  }
  //查看数据
  viewRow(data: any) {
    this.page.pagesize = this.pagesize;
    this.page.currentPage = this.currentPage;
    //console.log(this.page);
    this.$emit("formData", {
      pagename: "statisticalForm",
      WxQrCodePosterList: this.WxQrCodePosterList,
      WxQrCodePosterDetail: data,
      page: this.page
    });
  }
  //保存图片 GetSaveQrCode
  async GetQrCodeSave(data: any) {
    this.addQrCodeVisble = false;
    this.wxQrCodePosterListModel.QrCodeVal = data.SceneId;
    this.NickName = data.NickName;

    let params: any = {
      Input: [
        {
          Name: "model",
          value: this.wxQrCodePosterListModel
        },
        {
          Name: "update",
          value: false
        }
      ]
    };
    var res: any = await httpApi.GetSaveQrCode(params);
    console.log(data);
    if (res.ErrorCode == 0) {
      // this.GetQrCodeRowVisible = true;
      // this.QrCodeUrl = res.output[0].value;
      var alink = document.createElement("a");
      alink.href = res.output[0].value;
      alink.download = data.SceneId; //图片名
      alink.click();
      //this.GetQrCodePosterDetaila("");
    } else {
      this.$message.error("下载失败：" + res.ErrorMessage);
    }
  }
  GetQrCodeSaveTow() {
    var alink = document.createElement("a");
    alink.href = this.QrCodeUrl;
    alink.download = this.wxQrCodePosterListModel.QrCodeVal; //图片名
    alink.click();
  }
  //获取二维码
  async GetQrCodeRow(data: any) {
    console.log(data);
    this.dialogWidth = "500px";
    this.BeautifyQrCodeVisible = false;
    this.addQrCodeVisble = false;
    this.wxQrCodePosterListModel.QrCodeVal = data.SceneId;
    this.NickName = data.NickName;
    let params: any = {
      Input: [
        {
          Name: "model",
          value: this.wxQrCodePosterListModel
        },
        {
          Name: "update",
          value: false
        }
      ]
    };
    this.loading = true;
    var res: any = await httpApi.GetQrCodeData(params);
    this.loading = false;
    console.log(res);
    if (res.ErrorCode == 0) {
      this.GetQrCodeRowVisible = true;
      this.QrCodeUrl = res.output[0].value;
      //this.GetQrCodePosterDetaila("");
    } else {
      this.$message.error("生成失败：" + res.ErrorMessage);
    }
  }
}
